module.exports = __webpack_public_path__ + "static/media/chef.39c6f4c3.png";